// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"e2bfd5d1","286":"06ac518d","408":"207c746a","743":"fd13a00b","862":"ea8e0e03","878":"200f9a64","917":"3491d676"}[chunkId] + ".chunk.js";
};